import * as React from 'react'

const PageNotFound = () => {
	const path = window.location.pathname

	return (
		<div className="unauth-page">
			<h1 data-testid="unauth-header">404</h1>
			<p>Oops! The page you are looking for does not exist. It might have been moved or deleted.</p>
			<div>
				<button className="go-back"
					onClick={() => window.location.href = "/"}
				>Home Page</button>
			</div>
		</div>
	)
}

export default PageNotFound
